<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-app id="inspire">
      <v-layout
        wrap
        justify-center
        class="login_page"
        py-4
        :style="{
          'background-image': 'url(' + mediaURL + backgroundImage + ')',
        }"
      >
        <v-flex xs12 sm8 md7 lg5 xl5 px-2 align-self-center>
          <v-layout wrap justify-center>
            <v-flex xs112 xl8>
              <SnackBar
                v-bind:msg="msg"
                v-bind:showSnackBar="showSnackBar"
                @stepper="showSnackBar = false"
              />
              <v-card tile flat>
                <v-layout wrap justify-center>
                  <v-flex px-8 py-6>
                    <v-layout wrap justify-center>
                      <v-flex xs12>
                        <span
                          style="
                            font-family: poppinsmedium;
                            font-size: 15px;
                            color: #b8b8b8;
                          "
                          >Welcome to</span
                        >
                      </v-flex>
                      <v-flex xs12 py-4>
                        <span class="ibmsemibold large">KL 06</span> 
                      </v-flex>
                      <!-- <v-flex xs12 py-4>
                        <v-img
                          src="./../../assets/logo.png"
                          height="20px"
                          contain
                        ></v-img>
                      </v-flex> -->
                      <v-flex xs12>
                        <v-layout wrap justify-center>
                          <v-flex xs6 lg4 px-2>
                            <span
                              style="
                                font-family: poppinssemibold;
                                font-size: 15px;
                                color: #000;
                              "
                            >
                              Log in
                            </span>
                            <!-- <v-progress-linear
                              height="2"
                              value="100"
                              color="#EC2300"
                            ></v-progress-linear> -->
                          </v-flex>
                          <v-flex xs6 lg4 px-2>
                            <v-layout wrap justify-center>
                              <v-flex xs12>
                                <span
                                  style="
                                    font-family: poppinssemibold;
                                    font-size: 15px;
                                    color: #000;
                                  "
                                >
                                  Sign up
                                </span>
                              </v-flex>
                              <v-flex xs6 pt-2>
                                <v-progress-linear
                                  height="2"
                                  value="100"
                                  color="#EC2300"
                                ></v-progress-linear>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-layout pt-6 wrap justify-center>
                        <v-flex px-2 xs6 lg4>
                          <v-btn
                            block
                            tile
                            :ripple="false"
                            :outlined="!user.customer"
                            @click="userChange('customer')"
                            color="#ff0000"
                          >
                            <span
                              :style="
                                user.customer
                                  ? { color: '#fff' }
                                  : { color: '#2D2D2D' }
                              "
                              style="
                                font-family: poppinssemibold;
                                font-size: 16px;
                                text-transform: none;
                              "
                              >Customer</span
                            >
                          </v-btn>
                        </v-flex>
                        <v-flex px-2 xs6 lg4>
                          <v-btn
                            block
                            tile
                            :ripple="false"
                            :outlined="!user.seller"
                            @click="userChange('seller')"
                            color="#ff0000"
                          >
                            <span
                              :style="
                                user.seller
                                  ? { color: '#fff' }
                                  : { color: '#2D2D2D' }
                              "
                              style="
                                font-family: poppinssemibold;
                                font-size: 16px;
                                text-transform: none;
                              "
                              >Seller</span
                            >
                          </v-btn>
                        </v-flex>
                      </v-layout>
                      <v-flex xs12 pt-4>
                        <v-layout wrap>
                          <v-flex xs12 text-left>
                            <span
                              style="
                                font-family: ;
                                font-size: 14px;
                                color: #ababab;
                              "
                              class="pl-3"
                              >Your First Name
                            </span>
                            <v-text-field
                              ref="fullName"
                              color="#828282"
                              placeholder="First Name"
                              outlined
                              type="text"
                              dense
                              :rules="[rules.required]"
                              v-model="firstname"
                            ></v-text-field>
                            <span
                              style="
                                font-family: ;
                                font-size: 14px;
                                color: #ababab;
                              "
                              class="pl-3"
                              >Your Last Name
                            </span>
                            <v-text-field
                              ref="fullName"
                              color="#828282"
                              placeholder="Last Name"
                              outlined
                              dense
                              type="text"
                              :rules="[rules.required]"
                              v-model="lastname"
                            ></v-text-field>
                            <span
                              style="
                                font-family: ;
                                font-size: 14px;
                                color: #ababab;
                              "
                              class="pl-3"
                              >Enter your email ID
                            </span>
                            <v-text-field
                              ref="email"
                              color="#828282"
                              placeholder="Email ID"
                              outlined
                              type="text"
                              dense
                              :rules="[rules.required, rules.email]"
                              v-model="email"
                            ></v-text-field>
                            <span
                              style="
                                font-family: ;
                                font-size: 14px;
                                color: #ababab;
                              "
                              class="pl-3"
                              >Enter your Password
                            </span>
                            <v-text-field
                              ref="password"
                              type="password"
                              color="#828282"
                              placeholder="Password"
                              outlined
                              dense
                              :rules="[rules.required, rules.min]"
                              v-model="password"
                            ></v-text-field>
                            <span
                              style="
                                font-family: ;
                                font-size: 14px;
                                color: #ababab;
                              "
                              class="pl-3"
                            >
                              Confirm Password
                            </span>
                            <v-text-field
                              ref="confirmPassword"
                              color="#828282"
                              type="password"
                              placeholder="Confirm Password"
                              outlined
                              dense
                              :rules="[rules.required, rules.min, rules.check]"
                              v-model="confirmPassword"
                            ></v-text-field>

                            <span
                              style="
                                font-family: ;
                                font-size: 14px;
                                color: #ababab;
                              "
                              class="pl-3"
                            >
                              Pincode
                            </span>
                            <v-text-field
                              ref="pincode"
                              color="#828282"
                              placeholder="Pincode"
                              outlined
                              dense
                              type="number"
                              :rules="[rules.required, rules.pincode]"
                              v-model="pincode"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>

                    <v-layout wrap>
                      <v-flex pl-2 md12 text-left text-capitalize>
                        <span
                          style="
                            font-family: poppinsbold;
                            font-size: 18px;
                            font-weight: 400;
                            color: #000;
                          "
                        >
                          Verify
                        </span>
                      </v-flex>
                    </v-layout>

                    <v-layout wrap>
                      <v-flex py-2 pl-2 text-left>
                        <span
                          style="
                            font-family: kumbhsansregular;
                            font-size: 12px;
                            color: #ababab;
                          "
                        >
                          We have sent 4 digit OTP on +91-{{ phone }}
                        </span>
                      </v-flex>
                      <v-flex py-2 text-right>
                        <span
                          style="
                            font-family: poppinsregular;
                            font-size: 13px;
                            color: #de4d4d;
                            cursor: pointer;
                          "
                          @click="winStepper"
                        >
                          Change
                        </span>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          ref="otp"
                          label="Enter your OTP"
                          type="number"
                          color="#828282"
                          outlined
                          dense
                          :rules="[rules.required, rules.otp]"
                          v-model="otp"
                        ></v-text-field>
                      </v-flex>
                      <v-flex text-left pl-2>
                        <span
                          v-if="!otpexpired"
                          style="
                            font-family: poppinsregular;
                            font-size: 13px;
                            color: #515151;
                          "
                        >
                          Waiting for OTP... {{ timeLeft }} sec
                        </span>
                        <span
                          v-if="otpexpired"
                          style="
                            font-family: poppinsregular;
                            font-size: 13px;
                            color: #515151;
                            cursor: pointer;
                          "
                          @click="sentOTP"
                        >
                          Resend OTP
                        </span>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap justify-end>
                      <v-flex xs12 md4 pt-4 text-right>
                        <v-btn
                          block
                          dark
                          tile
                          color="#3EA56E"
                          depressed
                          class="text-capitalize"
                          @click="validateInput"
                          :ripple="false"
                        >
                          <span
                            style="
                              font-family: poppinssemibold;
                              font-size: 14px;
                            "
                          >
                            Continue
                          </span>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout wrap justify-center>
                  <v-flex py-4>
                    <v-divider></v-divider>
                  </v-flex>
                </v-layout>
                <v-layout wrap justify-center pb-4 align-center>
                  <v-flex text-left pl-8>
                    <span
                      style="
                        font-family: poppinsmedium;
                        font-size: 12px;
                        color: #040404;
                        cursor: pointer;
                      "
                      @click="winStepper"
                      >Already a member?</span
                    >
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-app>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["pageData", "lastPage", "backgroundImage"],
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,

      firstname: null,
      lastname: null,
      email: null,
      password: "",
      phone: null,
      confirmPassword: "",
      pincode: "",
      otp: "",
      timeLeft: "00:00",
      intervalTimer: null,
      otpexpired: false,
      user: {
        customer: true,
        seller: false,
      },
      type: "Client",
      valid: false,
      rules: {
        // required: (value) => !!value || "Required.",
        min: (value) => value.length >= 8 || "Min 8 characters",
        pincode: (value) => value.length == 6 || "Please provide valid pincode",
        otp: (value) => value.length == 4 || "Please provide valid otp",
        check: (confirmation) =>
          confirmation === this.password || "Passwords do not match",
      // },
      // rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        phoneRules: [
          (v) => !!v || "phone is required",
          (v) =>
            (v && v.length <= 10) || "number must be less than 11 characters",
          (v) =>
            (v && v.length >= 10) ||
            "number must be greater than 10 characters",
          (v) => /^\d{10}$/.test(v) || "phone number must be a number",
        ],
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },

      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) =>
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || "E-mail must be valid",
      ],
    };
  },

  beforeMount() {
      if ( this.$store.state.loginAlternate)
      localStorage.setItem("regType","Client");
    var user = localStorage.getItem("regType");
    // console.log(localStorage.getItem("regType"), "fghjk");
    if (user == "Seller") {
      this.user.customer = false;
      this.user.seller = true;
      this.type = "Seller";
    }
    //  && localStorage.getItem("regType")=='Client'
  
    this.setTime(180);
    this.phone = this.pageData.phone;
  },
//   watch:{
//     $route (to, from){
//         this.show = false;
//     }
// } ,
  mounted() {
    this.setMetaTags();
  },
  methods: {
    setMetaTags() {
      document.title = "Register | KL-06 FARM";
      let metaDescription = document.querySelector('meta[name="description"]');
      const description = "Create a new customer or seller account at KL-06 FARM to start shopping or selling.";
      if (metaDescription) {
        metaDescription.setAttribute('content', description);
      } else {
        metaDescription = document.createElement('meta');
        metaDescription.name = 'description';
        metaDescription.content = description;
        document.head.appendChild(metaDescription);
      }
    },
    userChange(item) {
      if (item == "customer") {
        this.user.customer = true;
        this.user.seller = false;
        this.type = "Client";
      } else {
        this.user.customer = false;
        this.user.seller = true;
        this.type = "Seller";
      }
    },
    winStepper() {
      this.$emit("stepper", {
        phone: this.pageData.phone,
        response: null,
        winStep: 0,
      });
    },
    goBack() {},
    sentOTP() {
      var userData = {};
      userData["phone"] = this.pageData.phone;
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/getsms",
        data: userData,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.setTime(180);
            this.otpexpired = false;
            this.msg = "OTP Sent Successfully";
            this.showSnackBar = true;
          } else {
            this.msg = "Something Went Wrong";
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    validateInput() {
      if (!this.firstname) {
        this.msg = "Please provide first name";
        this.showSnackBar = true;
        return;
      }
      if (!this.lastname) {
        this.msg = "Please provide last name";
        this.showSnackBar = true;
        return;
      }
      if (!this.email) {
        this.msg = "Please provide your email";
        this.showSnackBar = true;
        return;
      }
      if (!this.password) {
        this.msg = "Please provide your password";
        this.showSnackBar = true;
        return;
      }
      if (!this.confirmPassword) {
        this.msg = "Please confirm your password";
        this.showSnackBar = true;
        return;
      }
      if (!this.pincode) {
        this.msg = "Please provide your pincode";
        this.showSnackBar = true;
        return;
      }
      if (!this.otp || this.otp == "") {
        this.msg = "Please provide the OTP received in your mobile number";
        this.showSnackBar = true;
        return;
      }
      if (this.password != this.confirmPassword) {
        this.msg = "Passwords doesn't match";
        this.showSnackBar = true;
        return;
      }
      this.signUp();
    },
    signUp() {
      var userData = {};
      userData["firstname"] = this.firstname;
      userData["lastname"] = this.lastname;
      userData["email"] = this.email;
      userData["password"] = this.password;
      userData["phone"] = this.phone;
      userData["pincode"] = this.pincode;
      userData["otp"] = this.otp;
      userData["type"] = this.type;
      if (localStorage.getItem("guestId")) {
        userData["guestid"] = localStorage.getItem("guestId");
      }
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/weblogin",
        data: userData,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            localStorage.removeItem("regType");
           this.$store.commit("LOGIN_ALTERNATE",false)
            localStorage.setItem("token", response.data.data.token);
            this.$store.commit("changeCart", 0);
            this.$store.commit("changeWishlist", 0);
            this.$store.commit("userData", response.data.data);
            this.$store.commit("loginUser", response.data.status);
            this.$store.commit("userType", response.data.data.type);
            this.$store.commit("loginUser", true);
            if (
              localStorage.getItem("routeKey") &&
              response.data.data.type == "Client" 
            ) {
              this.$router.push(localStorage.getItem("routeKey"));
              localStorage.removeItem("routeKey");
            } else if (response.data.data.type == "Seller") {
              this.$router.push("/sellerRegistration");
            } else if (response.data.data.type == "Client") {
              this.$router.push("/");
            } else this.$router.push("/");
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    setTime(seconds) {
      clearInterval(this.intervalTimer);
      this.timer(seconds);
    },
    timer(seconds) {
      const now = Date.now();
      const end = now + seconds * 1000;
      this.displayTimeLeft(seconds);
      this.countdown(end);
    },
    countdown(end) {
      this.intervalTimer = setInterval(() => {
        const secondsLeft = Math.round((end - Date.now()) / 1000);
        if (secondsLeft == 0) this.otpexpired = true;
        if (secondsLeft < 0) {
          clearInterval(this.intervalTimer);
          return;
        }
        this.displayTimeLeft(secondsLeft);
      }, 1000);
    },
    displayTimeLeft(secondsLeft) {
      const minutes = Math.floor((secondsLeft % 3600) / 60);
      const seconds = secondsLeft % 60;
      var seconds1 = seconds;
      if (seconds < 10) seconds1 = "0" + seconds;
      this.timeLeft = "0" + minutes + " : " + seconds1;
      // this.timeLeft = seconds1;
    },
  },
};
</script>